module.exports = __webpack_public_path__ + "img/gd.0f4d0e07.svg";